import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { AuthRepository } from '../../../data/repository/auth/auth.repository';
import { UserRepository } from '../../../data/repository/user/user.repository';
import { AuthPostDto } from '../../dto/auth/auth-post.dto';
import { AuthValidator } from '../../validations/auth/auth.validator';
import { UserEntity } from '../../dto/auth/auth-get.dto';

@Injectable({
  providedIn: 'root',
})
export class AuthUsecase {
  constructor(private repository: AuthRepository, private validator: AuthValidator) {}

  auth(param: AuthPostDto): Observable<UserEntity> {
    const validator = this.validator.validateFields(param);
    if (validator.IsValid) {
      return this.repository.postAccessToken(param);
    } else {
      return throwError(() => validator.Errors);
    }
  }

  test() {
    return this.repository.getTest();
  }

  logout(): Observable<boolean> {
    localStorage.removeItem('authorization');
    return of(true);
  }
}
